<template>
  <section class="mb-8">
    <div class="text-h6 text-sm-h5 font-weight-bold mb-4">
      Resumo por Setor
    </div>
    <v-slide-group class="py-2">
      <v-slide-group-item
        v-for="sector in sectors"
        :key="sector.sector_id"
      >
        <v-card class="pa-4 mr-4" width="360">
          <div class="d-flex align-center ga-2 mb-4">
            <v-avatar :color="accessRateColor(sector.summary.access_rate)" size="32" class="pr-1">
              <v-icon icon="fa-solid fa-users" color="white" size="16" />
            </v-avatar>
            <span class="font-weight-bold">{{ sector.sector_name }}</span>
          </div>
          <v-row align="center">
            <v-col cols="4">
              <div class="text-h6 font-weight-bold">
                {{ sector.summary.generated }}
              </div>
              <div class="text-caption text-medium-emphasis">
                Emitidos
              </div>
            </v-col>
            <v-col cols="4">
              <div class="text-h6 font-weight-bold">
                {{ sector.summary.read }}
              </div>
              <div class="text-caption text-medium-emphasis">
                Computados
              </div>
            </v-col>
            <v-col cols="4" class="d-flex justify-center">
              <t-access-rate-gauge :rate="sector.summary.access_rate" />
            </v-col>
          </v-row>
        </v-card>
      </v-slide-group-item>
    </v-slide-group>
  </section>
</template>

<script lang="ts" setup>
import TAccessRateGauge, { accessRateColor } from '@/components/TAccessRateGauge.vue'
import type { AccessControlSector } from '@/types/AccessControl'

interface Props {
  sectors: AccessControlSector[]
}

defineProps<Props>()
</script>
